import { useLocation, Navigate } from "react-router-dom";

const LowercaseRedirect = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const search = location.search;
  const hash = location.hash;

  // Check if path contains uppercase letters
  if (/[A-Z]/.test(pathname)) {
    // Redirect to lowercase path with original search & hash
    return (
      <Navigate
        to={pathname.toLowerCase() + search + hash}
        replace
      />
    );
  }
  // Render nothing if no redirect needed
  return null;
};

export default LowercaseRedirect;
